import { storiesOf } from '@storybook/vue';
import { withKnobs, text, boolean, select } from '@storybook/addon-knobs';
import { action } from '@storybook/addon-actions';

import { BUTTON_TYPES } from '#components/@types/button';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Button group', () => ({
		template: `
		<el-button-group>
			<dms-button v-bind="propsA" text="Prev" @click="clickA" />
			<dms-button v-bind="propsB" iconOnRight text="Next" @click="clickB" />
		</el-button-group>
		`,
		methods: {
			clickA: action('clickA'),
			clickB: action('clickB'),
		},
		computed: {
			propsA() {
				return {
					type: this.typeA,
					icon: this.iconA,
					size: this.size,
					plain: this.plainA,
					disabled: this.disabledA,
				};
			},
			propsB() {
				return {
					type: this.typeB,
					icon: this.iconB,
					size: this.size,
					plain: this.plainB,
					disabled: this.disabledB,
				};
			},
		},
		props: {
			size: {
				default: select('Velikost', ['mini', 'small', 'medium', 'default'], 'mini'),
			},
			typeA: {
				default: select('Typ (A)', BUTTON_TYPES, 'primary'),
			},
			iconA: {
				default: text('Ikona (A)', 'el-icon-caret-left'),
			},
			plainA: {
				default: boolean('Zda je to jen jednoduché tlačítko (A)', false),
			},
			disabledA: {
				default: boolean('Disabled (A)', false),
			},
			typeB: {
				default: select('Typ (B)', BUTTON_TYPES, 'primary'),
			},
			iconB: {
				default: text('Ikona (B)', 'el-icon-caret-right'),
			},
			plainB: {
				default: boolean('Zda je to jen jednoduché tlačítko (B)', false),
			},
			disabledB: {
				default: boolean('Disabled (B)', false),
			},
		},
	}));
